import React, { useMemo, useState } from 'react'
import { exportarDashboardPDF } from '../components/exportarDashboardPDF'

import {
    useForm,
    Controller
} from 'react-hook-form'

import {
    useQuery
} from 'react-query'

import Select from 'react-select'

import api from '../components/api'

import DashboardGeracao
    from '../components/dashboards/residuos/DashboardGeracao'

import DashboardEvolucao
    from '../components/dashboards/residuos/DashboardEvolucao'

import DashboardComparacao
    from '../components/dashboards/residuos/DashboardComparacao'

import DashboardHistograma
    from '../components/dashboards/residuos/DashboardHistograma'

import DashboardDistribuicao
    from '../components/dashboards/residuos/DashboardDistribuicao'

import TabelaReferenciaIndicadores
    from '../components/dashboards/residuos/TabelaReferenciaIndicadores'

export default function ResiduosDashboard(props) {


    // =========================================================
    // CONFIGURAÇÕES
    // =========================================================

    const anoAtual =
        new Date().getFullYear() - 1


    const adesaoInstitucionalRecebida =
        props?.adesao_institucional_id
            ? Number(props.adesao_institucional_id)
            : null


    // =========================================================
    // FORM
    // =========================================================

    const {
        control,
        watch
    } = useForm({

        defaultValues: {

            adesao_institucional_id:
                adesaoInstitucionalRecebida || '',

            anos:
                [],

            modo:
                'RELATORIO',

            tipoDashboard:
                'geracao'

        }

    })


    const adesao_institucional_id =
        watch('adesao_institucional_id')

    const anosSelecionados =
        watch('anos') || []

    const tipoDashboard =
        watch('tipoDashboard')

    const modo =
        watch('modo')


    // =========================================================
    // ANOS
    // =========================================================

    const anos = []

    for (
        let x = anoAtual;
        x >= 2006;
        x--
    ) {

        anos.push(x)

    }


    const anosOptions =
        anos.map(ano => ({

            value:
                ano,

            label:
                String(ano)

        }))


    // =========================================================
    // LISTA DE HOSPITAIS
    // React Query 3
    // =========================================================

    const {
        data: hospitais = [],
        isLoading: loadingHospitais,
        isError: erroHospitais
    } = useQuery(

        'adesaoInstitucionalListaTodosDashboardResiduos',

        async () => {

            const result =
                await api.get(
                    'adesaoInstitucionalListaTodos/0'
                )

            return result.data || []

        },

        {
            refetchOnWindowFocus: false,

            staleTime:
                5 * 60 * 1000
        }

    )


    // =========================================================
    // OPÇÕES DO HOSPITAL
    // =========================================================

    const hospitaisOptions =
        useMemo(() => {

            if (!Array.isArray(hospitais)) {
                return []
            }


            return hospitais

                /*
                    Como este é o Dashboard de Resíduos,
                    mostramos somente hospitais participantes.

                    Se quiser TODOS os hospitais, remova
                    este .filter().
                */

                .filter(
                    item =>
                        item.residuo_ss === true
                )

                .map(item => {

                    const nome =
                        (
                            item.nome_fantasia ||
                            item.razao_social ||
                            ''
                        ).trim()


                    const municipio =
                        (
                            item.municipio ||
                            ''
                        ).trim()


                    const uf =
                        (
                            item.uf_codigo ||
                            ''
                        ).trim()


                    let local = ''

                    if (municipio && uf) {

                        local =
                            `${municipio} / ${uf}`

                    } else if (municipio) {

                        local =
                            municipio

                    } else if (uf) {

                        local =
                            uf

                    }


                    return {

                        value:
                            Number(
                                item.adesao_institucional_id
                            ),

                        label:
                            local
                                ? `${nome} - ${local}`
                                : nome,

                        hospital:
                            item

                    }

                })

                .sort(
                    (a, b) =>
                        a.label.localeCompare(
                            b.label,
                            'pt-BR'
                        )
                )

        }, [hospitais])


    // =========================================================
    // HOSPITAL SELECIONADO
    // =========================================================

    const hospitalSelecionado =
        hospitaisOptions.find(
            item =>
                Number(item.value) ===
                Number(adesao_institucional_id)
        ) || null

    const nomeHospital =
        hospitalSelecionado?.hospital?.nome_fantasia?.trim() ||
        hospitalSelecionado?.hospital?.razao_social?.trim() ||
        ''

    const [gerandoPDF, setGerandoPDF] = useState(false)

    const titulosDashboard = {
        geracao: 'Geração de Resíduos',
        evolucao: 'Evolução dos Indicadores',
        comparacao: 'Comparação com o Passado',
        histograma: 'Histograma de Geração Mensal',
        distribuicao: 'Distribuição Estatística'
    }

    const handleExportarPDF = async () => {
        if (gerandoPDF || !adesao_institucional_id) return

        try {
            setGerandoPDF(true)

            // Aguarda o React atualizar os gráficos sem animação
            await new Promise(resolve =>
                requestAnimationFrame(() =>
                    requestAnimationFrame(resolve)
                )
            )

            await new Promise(resolve => setTimeout(resolve, 150))

            await exportarDashboardPDF({
                elementoId: 'dashboard-residuos-conteudo',
                tabelaId: 'tabela-dashboard-residuos',
                titulo: titulosDashboard[tipoDashboard] || 'Dashboard de Resíduos',
                nomeHospital,
                nomeArquivo: `dashboard-residuos-${tipoDashboard}-${anosSelecionados.join('-') || 'todos'}.pdf`,
                logoUrl: `${process.env.PUBLIC_URL}/assets/pics/logo_HS.png`,
                anos: anosSelecionados
            })
        } catch (error) {
            console.error('Erro ao exportar dashboard:', error)
            window.alert('Não foi possível gerar o PDF. Tente novamente.')
        } finally {
            setGerandoPDF(false)
        }
    }

    // =========================================================
    // DASHBOARD
    // =========================================================

    const renderDashboard = () => {

        if (!adesao_institucional_id) {

            return (

                <div
                    className="alert alert-info"
                    style={{
                        marginTop: 20
                    }}
                >

                    Selecione um hospital para visualizar o dashboard.

                </div>

            )

        }


        switch (tipoDashboard) {


            case 'geracao':
                return (
                    <DashboardGeracao
                        adesao_institucional_id={Number(adesao_institucional_id)}
                        anos={anosSelecionados}
                        modo={modo}
                        exportandoPDF={gerandoPDF}
                    />
                )


            case 'comparacao':
                return (
                    <DashboardComparacao
                        adesao_institucional_id={Number(adesao_institucional_id)}
                        anos={anosSelecionados}
                        modo={modo}
                        exportandoPDF={gerandoPDF}
                    />
                )


            case 'evolucao':
                return (
                    <DashboardEvolucao
                        adesao_institucional_id={Number(adesao_institucional_id)}
                        anos={anosSelecionados}
                        modo={modo}
                        exportandoPDF={gerandoPDF}
                    />
                )

            case 'histograma':
                return (
                    <DashboardHistograma
                        adesao_institucional_id={Number(adesao_institucional_id)}
                        anos={anosSelecionados}
                        modo={modo}
                        exportandoPDF={gerandoPDF}
                    />
                )


            case 'distribuicao':

                return (
                    <DashboardDistribuicao
                        adesao_institucional_id={Number(adesao_institucional_id)}
                        nomeHospital={nomeHospital}
                        anos={anosSelecionados}
                        modo={modo}
                    />
                )


            default:

                return null

        }

    }


    


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div className="container-fluid">


            {/* =================================================
                CABEÇALHO
               ================================================= */}

            <div
                style={{
                    marginBottom: 25
                }}
            >

                <h3>
                    Dashboard - Resíduos de Serviços de Saúde
                </h3>

                <div className="text-muted">

                    Indicadores do Desafio Resíduos de Serviços de Saúde

                </div>

            </div>


            {/* =================================================
                FILTROS PRINCIPAIS
               ================================================= */}

            <div
                style={{

                    backgroundColor:
                        '#fff',

                    border:
                        '1px solid #ddd',

                    borderRadius:
                        8,

                    padding:
                        18,

                    marginBottom:
                        25

                }}
            >

                <div className="row">


                    {/* =========================================
                        HOSPITAL
                       ========================================= */}

                    <div className="col-md-5 col-sm-12">

                        <div className="form-group">

                            <label>
                                Hospital
                            </label>


                            <Controller

                                name="adesao_institucional_id"

                                control={control}

                                render={({ field }) => (

                                    <Select

                                        value={
                                            hospitalSelecionado
                                        }

                                        options={
                                            hospitaisOptions
                                        }

                                        isLoading={
                                            loadingHospitais
                                        }

                                        isDisabled={
                                            !!adesaoInstitucionalRecebida
                                        }

                                        isClearable={
                                            !adesaoInstitucionalRecebida
                                        }

                                        isSearchable={
                                            true
                                        }

                                        placeholder={
                                            loadingHospitais
                                                ? 'Carregando hospitais...'
                                                : 'Digite o nome do hospital...'
                                        }

                                        noOptionsMessage={() =>
                                            'Nenhum hospital encontrado'
                                        }

                                        loadingMessage={() =>
                                            'Carregando hospitais...'
                                        }

                                        onChange={option => {

                                            field.onChange(
                                                option
                                                    ? option.value
                                                    : ''
                                            )

                                        }}

                                    />

                                )}

                            />


                            {erroHospitais && (

                                <div
                                    className="text-danger"
                                    style={{
                                        marginTop: 5,
                                        fontSize: 12
                                    }}
                                >
                                    Erro ao carregar a lista de hospitais.
                                </div>

                            )}

                        </div>

                    </div>


                    {/* =========================================
                        ANO
                       ========================================= */}

                    <div className="col-md-3 col-sm-6">

                        <div className="form-group">

                            <label>
                                Ano
                            </label>


                            <Controller

                                name="anos"

                                control={control}

                                render={({ field }) => (

                                    <Select

                                        isMulti

                                        closeMenuOnSelect={false}

                                        options={
                                            anosOptions
                                        }

                                        value={
                                            anosOptions.filter(
                                                option =>
                                                    field.value?.includes(
                                                        option.value
                                                    )
                                            )
                                        }

                                        onChange={options => {

                                            field.onChange(
                                                options
                                                    ? options.map(
                                                        option =>
                                                            option.value
                                                    )
                                                    : []
                                            )

                                        }}

                                        placeholder="Todos os anos"

                                        noOptionsMessage={() =>
                                            'Nenhum ano encontrado'
                                        }

                                        isClearable

                                        isSearchable

                                    />

                                )}

                            />

                        </div>

                    </div>

                    {/* =========================================
                        MODO
                    ========================================= */}

                    <div className="col-md-2 col-sm-6">

                        <div className="form-group">

                            <label>
                                Modo
                            </label>

                            <Controller
                                name="modo"
                                control={control}
                                render={({ field }) => (

                                    <select
                                        {...field}
                                        className="form-control"
                                    >

                                        <option value="RELATORIO">
                                            Relatório
                                        </option>

                                        <option value="CORRECAO">
                                            Correção
                                        </option>

                                    </select>

                                )}
                            />

                        </div>

                    </div>


                    {/* =========================================
                        DASHBOARD
                       ========================================= */}

                    <div className="col-md-2 col-sm-6">

                        <div className="form-group">

                            <label>
                                Dashboard
                            </label>


                            <Controller

                                name="tipoDashboard"

                                control={control}

                                render={({ field }) => (

                                    <select
                                        {...field}
                                        className="form-control"
                                    >

                                        <option value="geracao">
                                            Geração de Resíduos
                                        </option>

                                        <option value="evolucao">
                                            Evolução dos indicadores
                                        </option>

                                        <option value="comparacao">
                                            Comparação com o passado
                                        </option>

                                        <option value="histograma">
                                            Histograma geração mensal
                                        </option>
                                        <option value="distribuicao">
                                            Distribuição estatística
                                        </option>

                                    </select>

                                )}

                            />

                        </div>

                    </div>


                </div>

            </div>




                    {
                        /*


                    {/* =================================================
                        HOSPITAL SELECIONADO
                    ================================================= 

                    {hospitalSelecionado && (

                        <div
                            style={{

                                backgroundColor:
                                    '#f5f9fc',

                                borderLeft:
                                    '4px solid #1683c7',

                                padding:
                                    '10px 15px',

                                marginBottom:
                                    20,

                                borderRadius:
                                    4

                            }}
                        >


                    <strong>
                        {
                            hospitalSelecionado
                                .hospital
                                .nome_fantasia
                                ?.trim()
                        }
                    </strong>


                        {hospitalSelecionado
                            .hospital
                            .municipio && (

                            <span className="text-muted">

                                {' — '}

                                {
                                    hospitalSelecionado
                                        .hospital
                                        .municipio
                                        .trim()
                                }

                                {
                                    hospitalSelecionado
                                        .hospital
                                        .uf_codigo
                                        ? ` / ${hospitalSelecionado.hospital.uf_codigo.trim()}`
                                        : ''
                                }

                            </span>

                        )}


                            <span
                            className="text-muted"
                            style={{
                                marginLeft: 10
                            }}
                        >

                            ID: {
                                hospitalSelecionado.value
                            }

                        </span>


                </div>

            )}


                        */
                    }
                   

            {/* =================================================
                DASHBOARD E EXPORTAÇÃO
            ================================================= */}

            <div style={{ minHeight: 500 }}>

                {adesao_institucional_id && tipoDashboard !== 'distribuicao' && (
                    <div
                        className="d-flex justify-content-end"
                        style={{ marginBottom: 15 }}
                    >
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleExportarPDF}
                            disabled={gerandoPDF}
                        >
                            <i
                                className={`fa ${
                                    gerandoPDF
                                        ? 'fa-spinner fa-spin'
                                        : 'fa-file-pdf-o'
                                }`}
                                style={{ marginRight: 8 }}
                            />

                            {gerandoPDF ? 'Gerando PDF...' : 'Exportar PDF'}
                        </button>
                    </div>
                )}

                <div
                    id="dashboard-residuos-conteudo"
                    style={{
                        backgroundColor: '#ffffff',
                        padding: 12,
                        height: 'auto',
                        overflow: 'visible'
                    }}
                >
                    {renderDashboard()}
                </div>

                {adesao_institucional_id && (
                    <div id="tabela-dashboard-residuos">
                        <TabelaReferenciaIndicadores />
                    </div>
                )}

            </div>


        </div>

    )

}